import React, { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import { LntPopover } from '@app/components/base'

import { useToggle } from '@app/hooks'
import { getInternalTasksNotification } from '@app/api/routes/internalTasksNotification'

import { INTERNAL_TASKS_NOTIFICATION_KEY } from '@app/constants/queryKeys'

import { NotificationList, NotificationButton } from './components'
import { checkForNewNotification, notificationListAdapter } from './utils'

export const NotificationMenu: React.FC = () => {
  const { data: internalTasksNotificationData } = useQuery({
    queryKey: [INTERNAL_TASKS_NOTIFICATION_KEY.internalTasksNotification],
    queryFn: async () => await getInternalTasksNotification()
  })

  const notificationListToggle = useToggle()

  const notificationList = useMemo(
    () => notificationListAdapter(internalTasksNotificationData),
    [internalTasksNotificationData]
  )

  const hasNewNotification = useMemo(() => checkForNewNotification(notificationList), [internalTasksNotificationData])

  const content = <NotificationList notificationList={ notificationList } />

  return (
    <LntPopover
      trigger='click'
      placement='top'
      arrow={ false }
      open={ notificationListToggle.value }
      content={ content }
      onOpenChange={ notificationListToggle.toggle }
    >
      <NotificationButton
        hasNotification={ hasNewNotification }
        onOpenNotificationMenu={ notificationListToggle.toggle }
      />
    </LntPopover>
  )
}
